export default __webpack_public_path__ + "static/media/320x320.96760f59.jpg";